<template>
  <header class="header container-fluid">
    <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
      <img class="p-2" :src="dogLogoUrl" :alt="logoAltText">
      <div v-if="amountRaised"
        class="header-stat flex-column gg-branding-supporting"
        :class="{millions: millionsRaised}"
      >
        <vue-odometer
          animation=""
          className="odometer dollars"
          format="(,ddd).dd"
          :value="amountRaised"
        />
        <span class="stat-label">Raised</span>
      </div>
      <div class="flex-column mt-2">
        <DonateCta />
        <AnimationToggle />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import VueOdometer from 'v-odometer/src'
import DonateCta from './DonateCta.vue'
import AnimationToggle from './AnimationToggle.vue'

export default {
  name: 'Header',
  components: {
    AnimationToggle,
    DonateCta,
    'vue-odometer': VueOdometer,
  },
  props: {
    dogLogoUrl: String,
    logoAltText: String,
  },
  computed: {
    ...mapGetters(['dogStat']),
    amountRaised () { return this.dogStat('total_amount_raised') },
    millionsRaised () { return this.amountRaised > 999999; }
  }
}
</script>

<style scoped lang="scss">
header {
  background-color: #eaeaea;

  > div {
    height: 100%;
  }

  img {
    width: 100px;
    background: white;
    border: solid 1vh #eaeaea;
    margin-top: 1.5vh;
    border-radius: 1vh;
  }
}
.header-stat {
  display: flex;
  justify-content: center;
  align-items: center;

  .odometer {
    font-size: 3rem;
    line-height: 1;
  }

  .stat-label {
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
  }
}

@media screen and (min-width: 768px) {
  header {
    height: 20vh;

    img {
      height: 100%;
      width: auto;
    }
  }

  .header-stat {
    .odometer {
      font-size: calc(5vh + 4vw);
    }

    &.millions .odometer {
      font-size: calc(3vh + 4vw);
    }

    .stat-label {
      font-size: 3vh;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
}

@media screen and (min-width: 992px) {
  .header-stat, .header-stat.millions {
    .odometer {
      font-size: 10vh;
    }
  }
}
</style>

<style>
/* Non-scoped odometer styling */
.odometer {
  font-weight: bold;
  white-space: nowrap;
}
.odometer.dollars .odometer-inside:before {
  content: "$";
}
</style>
